/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Productcategory1Inputs */

const de__field_productcategory1 = /** @type {(inputs: _Field_Productcategory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkte`)
};

/**

* @param {_Field_Productcategory1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_productcategory1 = /** @type {((inputs?: _Field_Productcategory1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Productcategory1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_productcategory1(inputs)
});
export { _field_productcategory1 as "_field_productCategory" }